import React  from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, entryForRole } from 'configs/AppConfig'

const PublicRoute = () => {

	const { token, user } = useSelector(state => state.auth)

	return token ? <Navigate to={user ? entryForRole(user.role) : AUTHENTICATED_ENTRY} /> : <Outlet/>
}

export default PublicRoute
